import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import './style.scss';

function ListItem({ onMouseDown: propsOnMouseDown, item, hover }) {
  const onMouseDown = () => {
    propsOnMouseDown(item);
  };

  return (
    <StyledContainer
      backgroundColor="white"
      backgroundHoverColor="grey"
      borderLeft
      borderRight
      borderBottom
      onMouseDown={onMouseDown}
      className={cx('inset-xs', 'autocomplete-item', {
        'autocomplete-item-hover': hover,
      })}
    >
      <Text>{item.name}</Text>
    </StyledContainer>
  );
}

ListItem.propTypes = {
  onMouseDown: PropTypes.func,
  item: PropTypes.object,
  hover: PropTypes.bool,
};

export default ListItem;
